import OrdersTable from "./OrdersTable";

export default function Completed() {
  return <OrdersTable type="completed" />;
}
